import { render, staticRenderFns } from "./sysUserGrade.vue?vue&type=template&id=93582d7c"
import script from "./sysUserGrade.vue?vue&type=script&lang=js"
export * from "./sysUserGrade.vue?vue&type=script&lang=js"
import style0 from "./sysUserGrade.vue?vue&type=style&index=0&id=93582d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports